import { Type, type StaticDecode } from 'typebox'
import { Value } from 'typebox/value'

import { Feature } from '@tadpoles/common'
import type {
    DecodeOnlyPersistenceCollectionDefinition,
    PersistenceCollection
} from '@tadpoles/persistence'

const FeatureStorageAssignment = Type.Object({
    childKey: Type.String({ minLength: 1 }),
    features: Type.Array(Type.Unknown())
})

export type FeatureAssignment = StaticDecode<typeof FeatureAssignment>
export const FeatureAssignment = Type.Object({
    childKey: Type.String({ minLength: 1 }),
    features: Type.Array(Feature)
})

type FeatureCollection = PersistenceCollection<FeatureAssignment, 'childKey'>

export type FamilyFeatureStore = FeatureCollection

export const FeatureCollectionDefinition: DecodeOnlyPersistenceCollectionDefinition<
    typeof FeatureStorageAssignment,
    FeatureAssignment,
    'childKey'
> = {
    kind: 'feature',
    scope: 'user',
    primaryKey: 'childKey',
    modelSchema: FeatureStorageAssignment,
    decode: (value) => Value.Decode(FeatureAssignment, value)
}
